var TabView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

TabView = (function() {
  function TabView(upload_options, tabs) {
    this.select_tab = __bind(this.select_tab, this);
    var tab, _i, _len;
    ObservableArray(this, 'tabs');
    Observable(this, 'loaded', null);
    for (_i = 0, _len = tabs.length; _i < _len; _i++) {
      tab = tabs[_i];
      this.tabs.push(Tab(tab, upload_options));
    }
  }

  TabView.prototype.select_tab = function(tab) {
    var t, _i, _len, _ref;
    _ref = this.tabs();
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      t = _ref[_i];
      t.selected(tab.name === t.name);
    }
    return this.loaded(tab);
  };

  return TabView;

})();

//# sourceMappingURL=0-tabs.js.map
